import React, { FC } from 'react';
import { Connect } from '../../Footer/Connect';
import { StageCardConnectMessageProps } from './props';
import './styles.scss';

export const ConnectAsWell: FC<StageCardConnectMessageProps> = ({ activeOpeningId, onConfirm }) => {
  return (
    <div className="stage-card-connect-as-well-message">
      <div className="stage-card-connect-as-well-message__text">✨ Connect as well</div>

      <Connect
        activeOpeningId={activeOpeningId}
        buttonClassName="stage-card-connect-as-well-message__button"
        isButtonIconHidden={true}
        onConfirmTalent={onConfirm}
      />
    </div>
  );
};
